import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errorPinMatchMessage:
      'The 2 codes entered are not the same. Please re-enter your PIN code',
    successMessage: 'Your changes have been saved successfully!',
  },
  fr: {
    errorPinMatchMessage:
      'Les 2 codes renseignés ne sont pas les mêmes. Veuillez entrer de nouveau votre code PIN',
    successMessage: 'Vos modifications ont été enregistrées avec succès\xA0!',
  },
} as const);

export default locales;
